export const START_TIMER = "START_TIMER";
export const PAUSE_TIMER = "PAUSE_TIMER";
export const STOP_TIMER = "STOP_TIMER";
export const UPDATE_TIME = "UPDATE_TIME";
